export const WIN_SCORE = 75;
export const ALMOST_SCORE = 65;
const DAILY_EPOCH = new Date("2026-01-01T00:00:00Z");

export function verdictFromScore(score, backendVerdict) {
  if (backendVerdict) return backendVerdict;
  if (score >= WIN_SCORE) return "¡Me convenciste!";
  if (score >= ALMOST_SCORE) return "Casi casi";
  return "REBECA se queda con esta";
}

export function dailyChallengeNumber(dateIso) {
  if (!dateIso) return null;
  const day = new Date(`${dateIso}T12:00:00Z`);
  if (Number.isNaN(day.getTime())) return null;
  return Math.floor((day - DAILY_EPOCH) / 86400000) + 1;
}

export function buildCompactShare({ score, stance, isDaily = false, dailyDate = null }) {
  const num = isDaily ? dailyChallengeNumber(dailyDate) : null;
  const header = num ? `Convenceme #${num} 🔥` : "Convenceme 🎯";
  const stanceShort = (stance || "").length > 58 ? `${stance.slice(0, 58)}...` : stance;
  const emoji = score >= WIN_SCORE ? "🏆" : score >= ALMOST_SCORE ? "😤" : "💀";
  const result =
    score >= WIN_SCORE
      ? "Le gané a REBECA"
      : score >= ALMOST_SCORE
      ? "Casi le gané"
      : "REBECA me ganó";

  return `${header}\n"${stanceShort}"\n${emoji} ${score}/100 — ${result}\n¿Me superás? → convenceme.app/daily`;
}

export async function copyCompactShare(payload) {
  const text = buildCompactShare(payload);
  await navigator.clipboard.writeText(text);
  return text;
}
